import React, { useState, useEffect } from 'react';
import { notification } from '../../component/hocs/notification';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import * as XLSX from 'xlsx/xlsx.mjs';

import TraceabilityDetail from '../../component/utility/farmActivity/TraceabilityDetail';

import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Form,
    Input,
    Label,
    InputGroup,
    InputGroupText,
    Spinner,
    Button,
    Badge,
    Alert,
    Collapse
} from 'reactstrap';
import {
    FaEye,
    FaSearch,
    FaFileExcel,
    FaFilter,
    FaMapMarkerAlt,
    FaUser,
    FaSeedling,
    FaCalendarAlt,
    FaChevronDown,
    FaChevronUp,
    FaDownload,
    FaHistory,
    FaMapPin,
    FaLeaf
} from 'react-icons/fa';

const Traceability = () => {
    const [mode, setMode] = useState("1");
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [historicalDownloadLoading, setHistoricalDownloadLoading] = useState(false);
    const [filterCollapse, setFilterCollapse] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    // Filter states
    const [cropTypeOpt, setCropTypeOpt] = useState('');
    const [cropType, setCropType] = useState('0');
    const [cropOpt, setCropOpt] = useState('');
    const [crop, setCrop] = useState('0');
    const [cropVarietyOpt, setCropVarietyOpt] = useState('');
    const [cropVariety, setCropVariety] = useState('0');
    
    const [state, setState] = useState('0');
    const [district, setDistrict] = useState('0');
    const [block, setBlock] = useState('0');
    
    const [stateOpt, setStateOpt] = useState('');
    const [districtOpt, setDistrictOpt] = useState('');
    const [blockOpt, setBlockOpt] = useState('');

    const [farmerTable, setFarmerTable] = useState([]);
    const [traceDetail, setTraceDetail] = useState('');

    const get_main_list = async (e) => {
        e.preventDefault();
        await farmer_list_handler();
    };

    useEffect(() => {
        get_crop_type();
        get_state_list();
    }, []);

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (value === '') {
            setFilteredData(farmerTable);
        } else {
            const filtered = farmerTable.filter(item =>
                item.name.toLowerCase().includes(value.toLowerCase()) ||
                item.state.toLowerCase().includes(value.toLowerCase()) ||
                item.district.toLowerCase().includes(value.toLowerCase()) ||
                item.block.toLowerCase().includes(value.toLowerCase()) ||
                item.village.toLowerCase().includes(value.toLowerCase()) ||
                item.date.includes(value)
            );
            setFilteredData(filtered);
        }
    };

    useEffect(() => {
        setFilteredData(farmerTable);
    }, [farmerTable]);

    const farmer_list_handler = async () => {
        setLoading(true);
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "crop_variety_code": cropVariety,
                "state_code": state,
                "dist_code": district,
                "block_code": block,
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/trace_view_web',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => {
                return {
                    sl: index + 1,
                    state: row.state_name,
                    district: row.dist_name,
                    block: row.block_name,
                    panchayat: row.pan_id,
                    village: row.vill_name,
                    name: row.f_name + " (" + row.batch_no + ")",
                    date: row.pop_start_date.split(" ")[0].split('-').reverse().join('-'),
                    action: (
                        <Button
                            color="info"
                            size="sm"
                            outline
                            className="d-flex align-items-center gap-1"
                            onClick={() => traceability_detail_handler(row)}
                        >
                            <FaEye size={14} />
                            View
                        </Button>
                    ),
                    rawData: row
                };
            });

            setFarmerTable(list);
            
            let notify = notification({
                message: `${list.length} farming records loaded successfully`,
                type: 'success'
            });
            notify();
        } catch (error) {
            let notify = notification({
                message: "Failed to load farming records. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setLoading(false);
        }
    };

    const get_crop_type = async () => {
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/box_crop_type_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => (
                <option key={row.crop_type_id} value={row.crop_type_id}>
                    {row.crop_type_name}
                </option>
            ));

            setCropTypeOpt(list);
        } catch (error) {
            console.error('Error fetching crop types:', error);
        }
    };

    const get_crop_list = async (e) => {
        setCropOpt('');
        setCrop("0");
        setCropType(e.target.value);
        
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "crop_type_id": e.target.value,
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/box_crop_master_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => (
                <option key={row.crop_code} value={row.crop_code}>
                    {row.crop_name}
                </option>
            ));

            setCropOpt(list);
        } catch (error) {
            console.error('Error fetching crops:', error);
        }
    };

    const crop_variety_list = async (e) => {
        setCrop(e.target.value);
        
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "crop_code": e.target.value,
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/box_crop_variety_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => (
                <option key={row.crop_variety_code} value={row.crop_variety_code}>
                    {row.crop_variety_name}
                </option>
            ));

            setCropVarietyOpt(list);
        } catch (error) {
            console.error('Error fetching crop varieties:', error);
        }
    };

    const get_state_list = async () => {
        try {
            let postData = [{ "country_code": "1" }];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_state_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => (
                <option key={row.state_code} value={row.state_code}>
                    {row.state_name}
                </option>
            ));

            setStateOpt(list);
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    const get_dist_list = async (e) => {
        setState(e.target.value);
        setDistrictOpt('');
        setBlockOpt('');
        setDistrict('0');
        setBlock('0');
        
        try {
            let postData = [{ "state_code": e.target.value }];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_dist_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => (
                <option key={row.district_code} value={row.district_code}>
                    {row.district_name}
                </option>
            ));

            setDistrictOpt(list);
        } catch (error) {
            console.error('Error fetching districts:', error);
        }
    };

    const get_block_list = async (e) => {
        setDistrict(e.target.value);
        setBlockOpt('');
        setBlock('0');
        
        try {
            let postData = [{ "dist_code": e.target.value }];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_block_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => (
                <option key={row.block_code} value={row.block_code}>
                    {row.block_name}
                </option>
            ));

            setBlockOpt(list);
        } catch (error) {
            console.error('Error fetching blocks:', error);
        }
    };

    const traceability_detail_handler = (row) => {
        setTraceDetail(row);
        setMode("3");
    };

    const download_excel_handler = async () => {
        setDownloadLoading(true);
        
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "pop_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/farmer_farming_details_ex',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => ({
                sl_no: index + 1,
                farmer_code: row.farmer_code,
                farmer_name: row.f_name,
                start_date: row.pop_start_date?.split(" ")[0].split('-').reverse().join('-'),
                crop_name: row.crop_name,
                area: row["concat(a.area_actual)"],
                harvesting: row.harvesting,
                selfconsume: row.selfconsume,
            }));

            if (list.length > 0) {
                let wb = XLSX.utils.book_new(),
                    ws = XLSX.utils.json_to_sheet(list);
                XLSX.utils.book_append_sheet(wb, ws, "Traceability_Report");
                XLSX.writeFile(wb, `traceability_report_${new Date().toISOString().split('T')[0]}.xlsx`);
                
                let notify = notification({
                    message: "Excel report downloaded successfully!",
                    type: 'success'
                });
                notify();
            } else {
                let notify = notification({
                    message: "No data available for download",
                    type: 'warning'
                });
                notify();
            }
        } catch (error) {
            let notify = notification({
                message: "Download failed. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setDownloadLoading(false);
        }
    };

    const download_historical_excel_handler = async () => {
        setHistoricalDownloadLoading(true);
        
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id')
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/traceability_history',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data;

            if (list.length > 0) {
                let wb = XLSX.utils.book_new(),
                    ws = XLSX.utils.json_to_sheet(list);
                XLSX.utils.book_append_sheet(wb, ws, "Historical_Data");
                XLSX.writeFile(wb, `traceability_historical_${new Date().toISOString().split('T')[0]}.xlsx`);
                
                let notify = notification({
                    message: "Historical data downloaded successfully!",
                    type: 'success'
                });
                notify();
            } else {
                let notify = notification({
                    message: "No historical data available",
                    type: 'warning'
                });
                notify();
            }
        } catch (error) {
            let notify = notification({
                message: "Historical data download failed. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setHistoricalDownloadLoading(false);
        }
    };

    const columns = [
        {
            name: '#',
            selector: row => row.sl,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaMapPin size={12} />
                    State
                </div>
            ),
            selector: row => row.state,
            sortable: true,
            width: '120px'
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaMapMarkerAlt size={12} />
                    District
                </div>
            ),
            selector: row => row.district,
            sortable: true,
            width: '120px'
        },
        {
            name: 'Block',
            selector: row => row.block,
            sortable: true,
            width: '100px'
        },
        {
            name: 'Village',
            selector: row => row.village,
            sortable: true,
            width: '120px'
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaUser size={12} />
                    Farmer Name
                </div>
            ),
            selector: row => row.name,
            sortable: true,
            width: "22%",
            cell: row => (
                <div className="text-truncate" title={row.name}>
                    {row.name}
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    Start Date
                </div>
            ),
            selector: row => row.date,
            sortable: true,
            width: '120px'
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '120px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Traceability Management' breadcrumbs='Home / Traceability'>
                <Row className='p-3'>
                    {mode === "1" && (
                        <Col xs={12}>
                            {/* Filter Section */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardHeader 
                                    className="bg-white border-bottom cursor-pointer"
                                    onClick={() => setFilterCollapse(!filterCollapse)}
                                >
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center gap-2">
                                            <FaFilter className="text-primary" />
                                            <h6 className="mb-0">Advanced Filters</h6>
                                        </div>
                                        {filterCollapse ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>
                                </CardHeader>
                                <Collapse isOpen={filterCollapse}>
                                    <CardBody>
                                        <Form onSubmit={get_main_list}>
                                            <Row>
                                                <Col sm={3} className="mb-3">
                                                    <Label for="type" className="d-flex align-items-center gap-1">
                                                        <FaSeedling size={14} className="text-success" />
                                                        Crop Type
                                                    </Label>
                                                    <Input 
                                                        id="type" 
                                                        bsSize="sm" 
                                                        type="select" 
                                                        value={cropType} 
                                                        onChange={get_crop_list}
                                                    >
                                                        <option value="0">--Select Crop Type--</option>
                                                        {cropTypeOpt}
                                                    </Input>
                                                </Col>
                                                <Col sm={3} className="mb-3">
                                                    <Label for="crop" className="d-flex align-items-center gap-1">
                                                        <FaLeaf size={14} className="text-success" />
                                                        Crop
                                                    </Label>
                                                    <Input 
                                                        id="crop" 
                                                        bsSize="sm" 
                                                        type="select" 
                                                        value={crop} 
                                                        onChange={crop_variety_list}
                                                        disabled={cropType === '0'}
                                                    >
                                                        <option value="0">--Select Crop--</option>
                                                        {cropOpt}
                                                    </Input>
                                                </Col>
                                                <Col sm={3} className="mb-3">
                                                    <Label for="cropVariety">Crop Variety</Label>
                                                    <Input 
                                                        id="cropVariety" 
                                                        bsSize="sm" 
                                                        type="select" 
                                                        value={cropVariety} 
                                                        onChange={(e) => setCropVariety(e.target.value)}
                                                        disabled={crop === '0'}
                                                    >
                                                        <option value="0">--Select Variety--</option>
                                                        {cropVarietyOpt}
                                                    </Input>
                                                </Col>
                                                <Col sm={3} className="mb-3">
                                                    <Label for="state" className="d-flex align-items-center gap-1">
                                                        <FaMapPin size={14} className="text-primary" />
                                                        State
                                                    </Label>
                                                    <Input 
                                                        id="state" 
                                                        bsSize="sm" 
                                                        type="select" 
                                                        value={state} 
                                                        onChange={get_dist_list}
                                                    >
                                                        <option value="0">--Select State--</option>
                                                        {stateOpt}
                                                    </Input>
                                                </Col>
                                                <Col sm={3} className="mb-3">
                                                    <Label for="district" className="d-flex align-items-center gap-1">
                                                        <FaMapMarkerAlt size={14} className="text-primary" />
                                                        District
                                                    </Label>
                                                    <Input 
                                                        id="district" 
                                                        bsSize="sm" 
                                                        type="select" 
                                                        value={district} 
                                                        onChange={get_block_list}
                                                        disabled={state === '0'}
                                                    >
                                                        <option value="0">--Select District--</option>
                                                        {districtOpt}
                                                    </Input>
                                                </Col>
                                                <Col sm={3} className="mb-3">
                                                    <Label for="block">Block</Label>
                                                    <Input 
                                                        id="block" 
                                                        bsSize="sm" 
                                                        type="select" 
                                                        value={block} 
                                                        onChange={(e) => setBlock(e.target.value)}
                                                        disabled={district === '0'}
                                                    >
                                                        <option value="0">--Select Block--</option>
                                                        {blockOpt}
                                                    </Input>
                                                </Col>
                                                <Col sm={3} className="mb-3 d-flex align-items-end">
                                                    <Button 
                                                        color='primary' 
                                                        size="sm" 
                                                        type="submit"
                                                        disabled={loading}
                                                        className="d-flex align-items-center gap-2 w-100"
                                                    >
                                                        {loading ? (
                                                            <Spinner size="sm" />
                                                        ) : (
                                                            <FaSearch size={14} />
                                                        )}
                                                        {loading ? 'Loading...' : 'Search Records'}
                                                    </Button>
                                                </Col>
                                                <Col sm={3} className="mb-3 d-flex align-items-end">
                                                    <div className="d-flex flex-column gap-2 w-100">
                                                        <Button 
                                                            color='secondary' 
                                                            size="sm" 
                                                            onClick={download_excel_handler}
                                                            disabled={downloadLoading || farmerTable.length === 0}
                                                            className="d-flex align-items-center gap-2 text-white"
                                                        >
                                                            {downloadLoading ? (
                                                                <Spinner size="sm" />
                                                            ) : (
                                                                <FaFileExcel size={14} />
                                                            )}
                                                            {downloadLoading ? 'Downloading...' : 'Download Report'}
                                                        </Button>
                                                        <Button 
                                                            color='info' 
                                                            size="sm" 
                                                            onClick={download_historical_excel_handler}
                                                            disabled={historicalDownloadLoading}
                                                            className="d-flex align-items-center gap-2 text-white"
                                                        >
                                                            {historicalDownloadLoading ? (
                                                                <Spinner size="sm" />
                                                            ) : (
                                                                <FaHistory size={14} />
                                                            )}
                                                            {historicalDownloadLoading ? 'Downloading...' : 'Historical Data'}
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Collapse>
                            </Card>

                            {/* Statistics Cards */}
                            {farmerTable.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaUser size={24} className="mb-2" />
                                                <h5 className="mb-0">{farmerTable.length}</h5>
                                                <small>Total Farmers</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-success text-white">
                                            <CardBody className="text-center py-3">
                                                <FaMapPin size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {new Set(farmerTable.map(item => item.state)).size}
                                                </h5>
                                                <small>States Covered</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <FaMapMarkerAlt size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {new Set(farmerTable.map(item => item.district)).size}
                                                </h5>
                                                <small>Districts</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaSeedling size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {new Set(farmerTable.map(item => item.village)).size}
                                                </h5>
                                                <small>Villages</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <Row className="align-items-center">
                                        <Col md={6}>
                                            <div>
                                                <h5 className="mb-0">Farmer Cultivation Records</h5>
                                                <small className='text-muted'>
                                                    {filteredData.length > 0 ?
                                                        `Showing ${filteredData.length} of ${farmerTable.length} records` :
                                                        'No cultivation records found'
                                                    }
                                                </small>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="d-flex justify-content-end align-items-center gap-2">
                                                {searchTerm && (
                                                    <Badge color="secondary">
                                                        Filtered: {filteredData.length}
                                                    </Badge>
                                                )}
                                                <InputGroup size="sm" style={{ maxWidth: '300px' }}>
                                                    <InputGroupText className="bg-light border-end-0">
                                                        <FaSearch className="text-muted" />
                                                    </InputGroupText>
                                                    <Input
                                                        type="search"
                                                        placeholder='Search farmers, locations...'
                                                        value={searchTerm}
                                                        onChange={(e) => handleSearch(e.target.value)}
                                                        className="border-start-0"
                                                    />
                                                </InputGroup>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {farmerTable.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaSeedling size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No cultivation records loaded yet</p>
                                            <small>Set your filters and click "Search Records" to load traceability data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={15}
                                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading cultivation records...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No records match your search criteria</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    )}

                    {mode === '3' && (
                        <Col xs={12}>
                            <TraceabilityDetail data={traceDetail} />
                            <div className="text-end mt-3">
                                <Button 
                                    color='primary' 
                                    size="sm" 
                                    onClick={() => setMode('1')}
                                    className="d-flex align-items-center gap-2"
                                >
                                    <FaChevronUp size={14} />
                                    Back to List
                                </Button>
                            </div>
                        </Col>
                    )}
                </Row>
            </Page>
            <Footer />
        </>
    );
};

export default Traceability;